
export default class CarouselItemsElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('carousel-items', CarouselItemsElement);